<template>
    <div class="cardComponente d-flex flex-column align-items-center"
        :class="isErro ? 'card-status-erro' : 'card-status-ok'">

        <div class="cardHeader d-flex justify-content-center align-items-center">
            <p class="m-0">{{ textoHeader }}</p>
        </div>

        <div class="cardBody d-flex flex-column w-100">
            <div class="d-flex justify-content-around w-100 text-center">
                <div class="d-flex flex-column">
                    <p class="mb-0 label-pequena">Bateria Rastreador</p>
                    <p :class="voltagemRastreador < 4 ? 'texto-vermelho' : 'texto-verde'">
                        {{ voltagemRastreador }}v </p>
                </div>
                <div class="d-flex flex-column">
                    <p class="mb-0 label-pequena">Bateria Caminhão</p>
                    <p :class="voltagemCaminhao < 23.0 ? 'texto-vermelho' : 'texto-verde'">
                        {{ voltagemCaminhao }}v </p>
                </div>
            </div>
            <div class="d-flex justify-content-between w-100 px-2">
                <div class="text-center">
                    <p class="m-0 label-botao">Localização</p>
                    <button @click="openLocationTab" class="btn-custom " :class="isErro ? 'btn-erro' : 'btn-ok'"><MapPinIcon class="icon-btn"/>  Ver no Maps</button>
                </div>
                <div class="text-center">
                    <p class="m-0 label-botao">Status Report</p>
                    <button @click="openStatusTab" class="btn-custom " :class="isErro ? 'btn-erro' : 'btn-ok'"> <FileTextIcon class="icon-btn"/>  Ver Status Report</button>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-between ">
            <p class="footerText m-0">Data Módulo: {{ dataModulo }}</p>
            <AlertCircleIcon class=" align-self-end m-1 icon-btn"   v-if="isErro" v-b-popover.hover.bottom="messageError.join('\n')" data-placement="bottom" data-popover/>
            </div>
        </div>
    </div>
</template>

<script>
	import environment from "@/environment";

	export default {
		name: "CardStatus",
		props: {
			textoHeader: { type: String },
			voltagemRastreador: { type: Number, default: 0 },
			voltagemCaminhao: { type: Number, default: 0 },
			dataModulo: { type: String },
			textoCardClass: { type: String },
			messageError: { type: Array, default: () => []},
			isErro: {
				type: Boolean,
				default: true
			},
			latitude: { type: Number, default: 0 },
			longitude: { type: Number, default: 0 },
			statusReport:{type: String}
		},
		methods: {
			openLocationTab () {
				const url = `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
				window.open(url, "_blank");
			},
			openStatusTab () {
				const url = `${environment.API_MONITOR}/${this.statusReport}`;
				window.open(url, "_blank");

			}
		}
	};
</script>

<style scoped>
.cardComponente {
    height: 160px;
    width: 230px;
    background-color: var(--bg-primario);
    border-radius: 16px;
    border: 2px solid var(--cor-erro);

}

.cardHeader {
    background-color: var(--cor-erro);
    height: 21px;
    width: 100%;
    font-size: 12px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    color: var(--bg-primario);

}


.cardBody {
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    padding: 0.5em;
    font-size: 11px;


}

.footerText {
    display: flex ;
    align-self: flex-start;
    justify-content: space-between;
    font-size: 11px;
    margin: 0;
    padding: 10px 0 0 10px;
    gap: 8px;

}

p {
    font-family: var(--fonte-light);
    white-space: pre-line;

}

.card-status-erro {
    border: 2px solid var(--cor-erro);
}

.card-status-erro .cardHeader {
    background-color: var(--cor-erro);
}

.card-status-ok {
    border: 2px solid var(--cor-ok);
}

.card-status-ok .cardHeader {
    background-color: var(--cor-ok);
}

.cardComponente:hover {
    cursor: pointer;
    opacity: 0.9;
}


.texto-vermelho {
    color: var(--cor-erro);
}

.texto-verde {
    color: var(--cor-ok);
}



.label-botao {
    font-size: 11px;
    margin-bottom: 2px;
}

.btn-custom {
    display: flex ;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: transparent;
    border-radius: 6px;
    padding: 0 4px;
    font-size: 10px;
    font-weight: bold;
    cursor: pointer;
    width: 95px;
    height: 25px;
    font-family: var(--fonte-semi-bold);
    gap: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}

.icon-btn {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
}

.btn-action {
    background: transparent;
    border-radius: 8px;
    padding: 2px 12px;
    font-size: 10px;
    font-weight: bold;
    transition: 0.3s;

}

.btn-ok {
    border: 1.5px solid var(--cor-ok);
    color: var(--cor-ok);
}

.btn-erro {
    border: 1.5px solid var(--cor-erro);
    color: var(--cor-erro);
}

.btn-action:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

</style>